export { useCurrentRoute } from './useCurrentRoute';
